'use strict';

var milanoAbitareApp = angular.module('milanoAbitareApp', [
    'milanoAbitareAppControllers',
    'ui.bootstrap'
]);

var milanoAbitareAppControllers = angular.module('milanoAbitareAppControllers', []);
